import * as React from 'react';
import { Label } from './TaskFilters.styles';
import { BooleanParam, useQueryParam } from 'use-query-params';
import { JobEscalation } from 'task-manager/types';
import { formatScreamingSnakesToPrettyStrings } from 'task-manager/formatScreamingSnakesToPrettyStrings';

type EscalatedFilterProps = {
  handleSelectChange: (value: string | string[], name: string) => void;
};

export const EscalatedFilter = ({ handleSelectChange }: EscalatedFilterProps) => {
  const [isEscalated] = useQueryParam('isEscalated', BooleanParam);
  return (
    <span key={'priorityFilter'}>
      <Label>Priority</Label>
      <select
        aria-label="isEscalated dropdown"
        name="isEscalated"
        value={
          isEscalated === undefined
            ? 'All'
            : isEscalated
            ? JobEscalation.ESCALATED
            : JobEscalation.NON_ESCALATED
        }
        onChange={({ target: { value, name } }) => handleSelectChange(value, name)}
      >
        <option value={undefined}>All</option>
        {Object.values(JobEscalation) // numerical enums return both the keys and values in a combined array
          .map(isEscalated => (
            <option value={isEscalated} key={isEscalated}>
              {formatScreamingSnakesToPrettyStrings(isEscalated)}
            </option>
          ))}
      </select>
    </span>
  );
};
